<template>
  <div>
    <v-card
      flat
      :loading="loading"
      class="tab-details"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text>
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.requests }}
        </div>
        <div
          v-if="showCreateRequest"
          class="text-left"
        >
          <router-link :to="`/cases/new-case-related-request/${isPega}/${caseObjectKey}/${requestObjectKey}`">
            <naj-button type="button">
              {{ local.home.tabCommon.newRequest }}
            </naj-button>
          </router-link>
        </div>
        <v-row class="mx-12">
          <template v-for="(request, index) in requests">
            <v-col
              :key="index"
              cols="4"
            >
              <request-card
                :request="request"
                :is-pega="isPega"
                :is-from-non-case-party="true"
                :parent-request-object-key="requestObjectKey"
              ></request-card>
            </v-col>
          </template>
          <v-col cols="12">
            <naj-no-data
              :has-data="requests && requests.length > 0"
              :loading="loading"
            ></naj-no-data>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <degree-color-palette></degree-color-palette>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
import { toHijriDate, getTimePart } from '@/helpers/utils';
import RequestCard from '@/modules/global/components/cards/request-card.vue';
import DegreeColorPalette from '../../../../case-file/degree-color-palette/index.vue';
import { userType } from '@/helpers/enum';

export default {
  name: 'CaseRequestsTab',
  components: {
    RequestCard,
    DegreeColorPalette,
  },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userType,
      showCreateRequest: false,
      requests: [],
      loading: false,
    };
  },
  mounted() {
    this.loadData();
    this.getUserInfo().then((user) => {
      // get user type to show/hide create new request
      this.showCreateRequest = user;// && user.userType != this.userType.najizOrganization;
    });
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapActions([
      'getNonCasePartyRequests',
    ]),
    toHijriDate,
    getTimePart,
    loadData() {
      const params = {
        objectKey: this.requestObjectKey,
        isPega: this.isPega,
      };
      this.loading = true;
      this.getNonCasePartyRequests(params)
        .then((res) => {
          this.requests = res.data;
        })
        // .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
  },
};

</script>

<style scoped >
</style>